/**
 * StatusWhatsapp
 * @author Simpli CLI generator
 */
import {$, Helper, Model, Request, Resource} from 'simpli-web-sdk'

export class StatusWhatsapp extends Resource {
  static readonly PENDENTE = 1
  static readonly APROVADO = 2
  static readonly REPROVADO = 3

  idWhatsappStatusPk: number = 0

  nome: string | null = null
  ativo: boolean | null = null

  get $id() {
    return this.idWhatsappStatusPk
  }
  set $id(val) {
    this.idWhatsappStatusPk = val
  }
  get $tag() {
    return String(this.nome)
  }
}
